import React from 'react';
import HeaderLayout from '../components/HeaderLayout';
import { Outlet } from 'react-router-dom';

const PrivateLayout = () => {
  return (
    <>
      <HeaderLayout />
      <Outlet />
    </>
  );
};

export default PrivateLayout;
